import React, {useState} from 'react';
import {Menu as PaperMenu} from 'react-native-paper';
import {View} from 'react-native';

import sy from '~/styles';

import {Menu} from '~/components/controls';
import MoreVertIcon from '~/images/md-icons/more_vert/materialicons/24px.svg';
import PropTypes from 'prop-types';

const MoreMenu = ({icon, items, disabled}) => {
  const [visible, setVisible] = useState(false);
  const has_leading_icon = items.some((item) => item.leadingIcon);

  if (disabled) {
    return <View style={sy['view-disabled']}>{icon ?? <MoreVertIcon />}</View>;
  }

  return (
    <Menu
      visible={visible}
      anchor={icon ?? <MoreVertIcon />}
      onShow={() => setVisible(true)}
      onDismiss={() => setVisible(false)}>
      {items.map(({title, leadingIcon, disabled, onPress}) => (
        <PaperMenu.Item
          key={title}
          title={title}
          leadingIcon={leadingIcon}
          disabled={disabled}
          titleStyle={
            !leadingIcon && has_leading_icon ? {paddingLeft: 56} : null
          }
          onPress={async () => {
            if (onPress) {
              await onPress();
            }

            setVisible(false);
          }}
        />
      ))}
    </Menu>
  );
};
MoreMenu.propTypes = {
  icon: PropTypes.any,
  items: PropTypes.any,
  disabled: PropTypes.any,
};

export default MoreMenu;
